import { ReactNode } from 'react';

interface GradientTextProps {
  children?: ReactNode;
  className?: string;
  gradient?: string;
}

export function GradientText({
  children,
  className = '',
  gradient = 'linear-gradient(to bottom, #FF7C0F 100% #FF9E0F 0%)',
}: GradientTextProps) {
  return (
    <span
      className={`inline-block ${className}`}
      style={{
        background: gradient,
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent',
      }}
    >
      {children}
    </span>
  );
}
